import { NgModule } from '@angular/core';
import { HtmlizePipe } from './htmlize.pipe';


@NgModule({
    declarations: [ HtmlizePipe ],
    exports: [ HtmlizePipe ],
    providers: [ HtmlizePipe ]
})
export class HtmlizePipeModule {}
